import { UrlParamReplace } from 'app/helpers/MiscUtils';
import { AdminJobfairs } from 'app/modules/admin/AdminJobfairs';
import { adminUrl } from 'app/types';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { ManageProfile } from '../shared/account/manage-profile';
import { AdminOrganizations } from './AdminOrganizations';
import { AdminUsers } from './AdminUsers';
import AdminLobby from './components/AdminLobby';
import ManageSponsors from './components/Sponsors/ManageSponsors';
import { AdminNotificationTemplates } from './notifications/AdminNotificationTemplates';
import { AdminUserManuals } from './user-manuals/AdminUserManuals';

export const AdminRoutes = {
  Jobfairs: `${adminUrl}/jobfairs`,
  Organizations: `${adminUrl}/companies`,
  Users: `${adminUrl}/users`,
  Lobby: `${adminUrl}/lobby/:orgId/:jobFairId`,
  BoothDetail: `${adminUrl}/lobby/booth/:boothId`,
  Sponsors: `${adminUrl}/sponsors`,
  EmailTemplates: `${adminUrl}/email-templates`,
  UserManuals: `${adminUrl}/user-manuals`,
  Profile: `${adminUrl}/profile`
};

const adminBreadCrumbs = [{
  text: 'Companies',
  url: UrlParamReplace(AdminRoutes.Organizations, '', '')
}
];

const AdminPage: React.FC = () => {
  return (
    <>

      <Switch>
        <Route path={AdminRoutes.Organizations}>
          <AdminOrganizations breadcrumbs={adminBreadCrumbs} title='Companies' />
        </Route>
        <Route path={AdminRoutes.Jobfairs} component={AdminJobfairs}>
        </Route>
        <Route path={AdminRoutes.Lobby}>
          <AdminLobby title="Event Lobby" />
        </Route>
        <Route path={AdminRoutes.Users}>
          <AdminUsers title='Users' />
        </Route>
        <Route path={AdminRoutes.Sponsors}>
          <ManageSponsors title='Sponsors' />
        </Route>
        <Route path={AdminRoutes.EmailTemplates}>
          <AdminNotificationTemplates />
        </Route>
        <Route path={AdminRoutes.UserManuals}>
          <AdminUserManuals title='User Manuals' />
        </Route>
        <Route path={AdminRoutes.Profile}>
          <ManageProfile title='Profile' />
        </Route>
        <Redirect from='/admin' to={AdminRoutes.Organizations} />
        <Redirect from='/sponsors' to={AdminRoutes.Sponsors} />
        <Redirect from={adminUrl} to={AdminRoutes.Organizations} />
        <Redirect to={AdminRoutes.Organizations} />
      </Switch>
    </>
  );
};

export default AdminPage;
